function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { range } from '@finect/front-utils/range';
import { withLeadingChar } from '@finect/front-utils/withLeadingChar';
import { longMonths } from '../../../../commons/locales/es_ES';
import { Chip } from '../../../../Chip';
import { FormControl, MonthBlock, ShortcutBlock } from './partials';
import { isNull } from './utils';
var getMinYear = function getMinYear(minDate) {
  if (!minDate) {
    return new Date().getFullYear();
  }
  return new Date(minDate).getFullYear();
};
var getMaxYear = function getMaxYear(maxDate, min) {
  if (!maxDate) {
    var minYear = getMinYear(min);
    return minYear + 10;
  }
  return new Date(maxDate).getFullYear();
};
var getValueFromState = function getValueFromState(state) {
  var month = state.month,
    year = state.year;
  if (isNull(month) || isNull(year)) {
    return null;
  }
  return "".concat(year, "-").concat(withLeadingChar(month, 2, '0'), "-01");
};
var MonthPicker = function (_React$Component) {
  _inherits(MonthPicker, _React$Component);
  var _super = _createSuper(MonthPicker);
  function MonthPicker() {
    var _this;
    _classCallCheck(this, MonthPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      month: null,
      year: null,
      shortcut: null
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      _this.props.onChange && _this.props.onChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMonthChange", function (event) {
      _this.setState({
        month: event.target.value
      }, function () {
        _this.handleChange(getValueFromState(_this.state));
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleYearChange", function (event) {
      _this.setState({
        year: event.target.value
      }, function () {
        _this.handleChange(getValueFromState(_this.state));
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleShortcut", function (shortcut) {
      _this.setState({
        shortcut: shortcut.date
      }, function () {
        _this.handleChange(shortcut.date);
      });
    });
    return _this;
  }
  _createClass(MonthPicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$field$pro = this.props.field.properties,
        properties = _this$props$field$pro === void 0 ? {} : _this$props$field$pro;
      var _ref = properties || {},
        _ref$shortcuts = _ref.shortcuts,
        shortcuts = _ref$shortcuts === void 0 ? [] : _ref$shortcuts,
        _ref$min = _ref.min,
        min = _ref$min === void 0 ? null : _ref$min,
        _ref$max = _ref.max,
        max = _ref$max === void 0 ? null : _ref$max;
      var month = Number(this.props.value ? this.props.value.split('-')[1] : this.state.month);
      var year = Number(this.props.value ? this.props.value.split('-')[0] : this.state.year);
      var yearMonth = "".concat(year, "-").concat(withLeadingChar(month, 2, '0'));
      var fromYear = getMinYear(min);
      var toYear = getMaxYear(max, min);
      return React.createElement("div", null, React.createElement(FormControl, null, React.createElement(MonthBlock, {
        size: "medium",
        isLeft: true
      }, React.createElement("select", {
        onChange: this.handleMonthChange
      }, React.createElement("option", {
        value: "null"
      }, "Mes"), longMonths.map(function (monthName, key) {
        var props = month === key + 1 ? {
          selected: true
        } : {};
        return React.createElement("option", _extends({
          key: key,
          value: key + 1
        }, props), monthName);
      }))), React.createElement(MonthBlock, {
        size: "medium",
        isRight: true
      }, React.createElement("select", {
        onChange: this.handleYearChange
      }, React.createElement("option", {
        value: "null"
      }, "A\xF1o"), range(toYear - fromYear + 1, fromYear).map(function (itYear) {
        var props = year === itYear ? {
          selected: true
        } : {};
        return React.createElement("option", _extends({
          key: itYear,
          value: itYear
        }, props), itYear);
      })))), React.createElement(ShortcutBlock, null, shortcuts.map(function (shortcut, key) {
        return React.createElement(Chip, {
          size: "medium",
          key: key,
          withIcon: false,
          value: shortcut.name,
          onAction: function onAction() {
            _this2.handleShortcut(shortcut);
          },
          isActive: shortcut.date.includes(yearMonth)
        });
      })));
    }
  }]);
  return MonthPicker;
}(React.Component);
export default MonthPicker;